<template>
  <div class="serviceList">
    <div v-if="dataList.length === 0 && !incomeListLoading" class="noContent">
      <img src="../../assets/images/blank_icon_project.png">
      <div class="blank-tip">暂无内容</div>
    </div>
    <van-list
      v-else
      class="list"
      :v-model="incomeListLoading"
      :finished="listLoadFinished"
      @load="getList"
    >
      <template v-for="(item, index) in dataList">
        <div class="template-title">{{ item.floorName }}</div>
        <div class="content-div">
          <template v-for="data in item.contents">
            <van-card @click="clickInfo(data)" v-if="data.contentTemplate == 4">
              <!--    4    下载-->
              <template #thumb>
                <div>
                  <img
                    v-if="data.img.substring(data.img.lastIndexOf('.') + 1) === 'doc'|| data.img.substring(data.img.lastIndexOf('.') + 1) ==='docx'"
                    class="van-image__img file-img" style="float: right" :src="wordImg"/>
                  <img
                    v-else-if="data.img.substring(data.img.lastIndexOf('.') + 1) === 'ppt'|| data.img.substring(data.img.lastIndexOf('.') + 1) ==='pptx'"
                    class="van-image__img file-img" style="float: right" :src="pptImg"/>
                  <img
                    v-else-if="data.img.substring(data.img.lastIndexOf('.') + 1) === 'xls' || data.img.substring(data.img.lastIndexOf('.') + 1) === 'xlsx'"
                    class="van-image__img file-img" style="float: right" :src="excelImg"/>
                  <img
                    v-else-if="data.img.substring(data.img.lastIndexOf('.') + 1) === 'pdf'"
                    class="van-image__img file-img" style="float: right" :src="pdfImg"/>
                  <img
                    v-else-if="data.img.substring(data.img.lastIndexOf('.') + 1) === 'txt'"
                    class="van-image__img file-img" style="float: right" :src="data.img"/>
                  <img v-else class="van-image__img file-img" style="float: right" :src="data.img"/>
                </div>
              </template>
              <template #title>
                <div class="card-title">{{ data.title }}</div>
              </template>
              <template #desc>
                <div class="card-introduce">文件大小：{{ data.introduce }}MB</div>
              </template>
              <template #price>
                <div class="txt-ft">日期：{{ data.createTime }}</div>
              </template>
            </van-card>

            <van-card @click="clickInfo(data)" v-else-if="data.contentTemplate == 3">
              <!--    3    标签-->
              <template #thumb>
                <img class="van-image__img" style="float: right" :src="data.img"/>
              </template>
              <template #title>
                <div class="card-title">{{ data.title }}</div>
              </template>
              <template #desc>
                <div class="card-introduce">{{ data.introduce }}</div>
              </template>
              <template #price>
                <van-tag v-if="data.tag" style="float: left" class="card-tag" round type="primary">{{
                    data.tag
                  }}
                </van-tag>
                <div style="float: right" class="card-price">{{ data.price }}</div>
              </template>
              <!--            <template #tags>-->
              <!--              <van-tag class="card-tag" round type="primary">{{ data.tag }}</van-tag>-->
              <!--            </template>-->
            </van-card>

            <div class="van-card" @click="clickInfo(data)"
                 v-else-if="data.contentTemplate == 1 || data.contentTemplate == 2">
              <!--    1    左图右文-->
              <div class="van-card__header">
                <a class="van-card__thumb">
                  <img class="van-image__img" :src="data.img" style="float: right;">
                </a>
                <div class="van-card__content">
                  <div>
                    <div class="card-title">{{ data.title }}</div>
                    <!--                  <div class="card-introduce">{{ data.introduce }}</div>-->
                  </div>
                  <div class="van-card__bottom">
                    <div class="txt-ft">
                      <div class="txt-tag" style="float: left;">{{ data.tag }}</div>
                      <span class="van-card__price-decimal" style="float: right;">阅读：{{ data.readNum }}</span></div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>
    </van-list>
  </div>
</template>

<script>
import {listContent, listContentMore} from '@api/service'

export default {
  name: "serviceList",
  data() {
    return {
      pageNum: 0,
      pageSize: 10,
      incomeListLoading: false,
      listLoadFinished: false,
      pageId: 6, // id
      dataList: [],
      queryParams: []
    }
  },
  created() {
    this.startTime = Date.now();
    // 初始化极光统计
    this.$jiguang.initCountEvent()
    this.getList()
  },
  methods: {

    // 查看详情
    clickInfo(data) {
      // this.enterRouter('detail', {id: id})
      let browTime = parseInt((Date.now() - this.startTime) / 1000)
      let brow = "h5_service_browser,服务信息,服务," + browTime
      // 初始化极光统计预览时长
      this.$jiguang.initBrowseEvent(brow)

      let url = `${process.env.VUE_APP_BASE_HOST}/service/detail?id=${data.id}`
      if (data.url) {
        url = data.url
      }

      const dataJson = {
        url: url,
        title: '详情'
      }
      this.$bridge.callHandler('newPage', dataJson, response => {
        console.log('response:', response)
      })
    },

    // 获取列表数据
    getList() {
      this.pageNum++
      this.incomeListLoading = true
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        pageId: this.pageId,
      }
      listContent(params).then(res => {
        if (res.data.code === 200) {
          this.incomeListLoading = false
          if (res.data.data && res.data.data.length === 0) {
            this.listLoadFinished = true
          } else {
            if (this.dataList.length > 0) {
              this.dataList[0].contents = this.dataList[0].contents.concat(res.data.data[0].contents)
            } else {
              this.dataList = this.dataList.concat(res.data.data)
            }
          }
          console.log('this.dataList', this.dataList)
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
  }
}
</script>

<style lang="scss">
@import "../../assets/css/mixin";

.serviceList {
  .basic {
    border-radius: 0;
  }

  .function-div {
    padding-top: 15px;

    .function-img {
      width: 40px;
      height: 40px;
    }

    .img-default {
      text-align: center;
      @include add_size($font_size_16);
      padding-bottom: 15px;
    }

  }


  .file-img {
    box-shadow: 0px 0px 4px 2px #f1f0f0;
  }

  .txt-ft {
    color: #999999;
    @include add_size($font_size_13);

    .readNum {
      padding-right: 10px;
    }
  }

  .content-div {
    background-color: white;

    .van-card {
      padding: 15px 0 14px 0;
      margin: 0 15px;
    }
  }

  .van-card {
    background-color: white;
    border-top: 0.5px solid #EEEEEE;
  }

  .template-title {
    padding-left: 15px;
    line-height: 40px;
    @include add_size($font_size_18);
    //font-weight: bold;
  }

  .card-title {
    @include add_size($font_size_18);
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //控制行数
    overflow: hidden;
  }

  .card-introduce {
    color: #999999;
    @include add_size($font_size_14);
    padding-top: 5px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //控制行数
    overflow: hidden;
  }

  .card-tag {
    background-color: #60CAF9;
    @include add_size($font_size_12);
    padding: 3px 8px;
  }

  .card-price {
    @include add_size($font_size_18);
    color: red;
  }

  .van-card__price {
    width: 100%;
    padding-top: 5px;
  }

  .load-more {
    text-align: center;
    padding-top: 10px;

    .van-button {
      border-radius: 15px;
      padding: 3px 10px;
    }
  }
}
</style>
